export * from './BoxCTA';
export { StyledBoxCTAButton, StyledBoxCTALink } from './BoxCTA.styles';

//# sourceMappingURL=index.js.map